import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["data-testid", "dividers", "options"];
import React from 'react';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { jsx as _jsx } from "react/jsx-runtime";
export function SelectOption(props) {
  var _props$dataTestid = props['data-testid'],
    testidSelectOption = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    dividers = props.dividers,
    options = props.options,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(StyledSelect, _extends({
    IconComponent: KeyboardArrowDownIcon,
    MenuProps: {
      PaperProps: {
        elevation: 0,
        sx: {
          border: '1px solid #484850',
          borderRadius: '6px',
          width: '200px'
        }
      },
      anchorOrigin: {
        horizontal: 'right',
        vertical: 'bottom'
      },
      transformOrigin: {
        horizontal: 'right',
        vertical: 'top'
      }
    },
    "data-testid": "".concat(testidSelectOption, "-SelectOption"),
    displayEmpty: true
  }, others, {
    "data-element": "StyledSelect",
    "data-component": "SelectOption",
    "data-source-file": "SelectOption.tsx",
    children: options.map(function (option, index) {
      return /*#__PURE__*/_jsx(StyledMenuItem, {
        "data-name": "".concat(option.value, "-optionItem"),
        "data-testid": "".concat(option.value, "-MenuItem"),
        isDivide: dividers == null ? void 0 : dividers.includes(index),
        value: option.value,
        children: option.label
      }, option.value);
    })
  }));
}
var StyledSelect = styled(Select)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiOutlinedInput-input': {
      padding: '3.5px 14px'
    },
    height: 30,
    padding: 0
  };
});
var StyledMenuItem = styled(MenuItem)(function (_ref2) {
  var isDivide = _ref2.isDivide,
    theme = _ref2.theme;
  return {
    borderBottom: isDivide ? "1px solid ".concat(theme.palette.grey[300]) : 'none'
  };
});